// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.register-code-label-col {
  display: flex;
  align-items: center;
}

.register-code-label-warning {
  color: #FFC107;
  margin-left: 8px;
  cursor: default;
}

#programs-tab-content mat-form-field {
  width: 100%;
}
#programs-tab-content mat-form-field input {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/apps/apps-editor/apps-editor.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,cAAA;EACA,gBAAA;EACA,eAAA;AACF;;AAGE;EACE,WAAA;AAAJ;AAEI;EACE,WAAA;AAAN","sourcesContent":[".register-code-label-col {\n  display: flex;\n  align-items: center;\n}\n\n.register-code-label-warning {\n  color: #FFC107;\n  margin-left: 8px;\n  cursor: default;\n}\n\n#programs-tab-content {\n  mat-form-field {\n    width: 100%;\n\n    input {\n      width: 100%;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
